import { BasePageBuilderAction } from '@bigcommerce/page-builder-sdk/src/index';

export interface ChildElementDetails {
    attribute: string;
    index: number;
}

export interface HighlightChildElementPayload extends BasePageBuilderAction {
    widgetUuid: string;
    payload: ChildElementDetails;
}

export enum PageBuilderApiActionType {
    HIGHLIGHT_CHILD_ELEMENT = 'highlight-child-element',
}
